import produce from 'immer';
import { ReducerAction } from 'store/modules/types';
import { Types, confirmarPlaca } from './types';

export const INITIAL_STATE: confirmarPlaca = {
	status: 0,
	data: null,
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerAction,
): confirmarPlaca {
	return produce(state, draft => {
		switch (action.type) {
			case Types.CONFIRMAR_PLACA_REQUEST: {
				break;
			}

			case Types.CONFIRMAR_PLACA_SUCCESS: {
				draft.status = action.payload.status;
				draft.data = action.payload.data;
				break;
			}

			case Types.CONFIRMAR_PLACA_FAILURE: {
				draft.status = action.payload.status;
				draft.data = action.payload.data;
				break;
			}
			case Types.CONFIRMAR_PLACA_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			default:
		}
		return draft;
	});
}
